export default "__VITE_ASSET__ab644ce7__"